import useFetchAndTrace from "../fetchWithTrace";
import settings from "../../../constants/settings";
import { SellerInventory } from "../../../reducers/componentSearch";

export default function useApproveDistributorForPart(
  onSuccess: () => void,
  onError: (detail: string) => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const approveInventoryHandler = (response: Response) => {
    if (response.ok) {
      onSuccess();
    } else {
      throw new Error("Unable to approve seller for part.");
    }
  };

  const errorHandler = () => {
    onError("Unable to approve seller for part.");
  };

  const approveDistributor = (
    sellerInventory: SellerInventory,
    partId: string,
    leadTime: number,
    expiration: string,
  ) => {
    void fetchAndTrace(
      `${settings.api_url}/parts/${partId}/approve-distributor`,
      approveInventoryHandler,
      errorHandler,
      {
        method: "PUT",
        body: JSON.stringify({
          octopart_seller_id: sellerInventory.octopart_seller_id,
          lead_time_days: leadTime,
          expiration: expiration,
        }),
      },
    );
  };

  return {
    approveDistributor,
  };
}
